import { Message } from '@gonfalon/messages/Message';

import { SignUpHeroCompanyLogos } from './SignUpHeroCompanyLogos';
import { SignUpValueProposition } from './SignUpValueProposition';

import styles from './SignUpHero.module.css';

export const SignUpHero = () => (
  <div className={styles.contentLayout}>
    <div className={styles.content}>
      <div className={styles.title}>
        <div>
          <Message id="onboarding.signUpHero.headingLine1" />
        </div>
        <div className={styles.titleText}>
          <Message id="onboarding.signUpHero.headingLine2" />
        </div>
      </div>
      <div className={styles.valuePropositions}>
        <SignUpValueProposition
          header="Get connected fast."
          content="With 30 idiomatic SDKs, you can start using feature flags in minutes."
        />

        <SignUpValueProposition
          header="Ship as a team."
          content="Share flags and review changes with built-in guardrails."
        />

        <SignUpValueProposition
          header="Build with confidence."
          content="Target precisely, improve continuously, release safely, and recover instantly, all in one platform."
        />
      </div>
    </div>
    <div className={styles.logoContent}>
      <div className={styles.logoText}>
        {' '}
        <Message id="onboarding.signUpHero.trustedBy" />
      </div>
      <SignUpHeroCompanyLogos />
    </div>
  </div>
);
